import React from 'react';
import 'antd/dist/antd.css';
import { Row, Col, Card, Typography } from 'antd';
import { useLocation } from 'react-router-dom';
// @ts-ignore
import ImagemLogo from '../../assets/logo_dark.png';
import FormSemContrato from './components/FormSemContrato';
import { useCadastreSe } from './useCadastreSe';
import './index.css';

const { Title, Paragraph } = Typography;

const CadastreSe: React.FC = () => {
    const location = useLocation();
    const { initialVendedorId, vendedorLocked, handleSuccess } = useCadastreSe();

    return (
        <Row className="cadastrese-page" gutter={0}>
            <Col span={24}>
                <div className="cadastrese-hero">
                    <div className="cadastrese-hero-inner">
                        <img src={ImagemLogo} alt="GovFácil" className="cadastrese-logo" />
                        <Title style={{ color: '#fff' }} level={2}>
                            Vamos começar?
                        </Title>
                        <Paragraph style={{ color: '#fff' }}>
                            Informe seus dados para acessar o GovFácil.
                        </Paragraph>
                    </div>
                </div>
                <div className="cadastrese-card-wrap">
                    <Card className="cadastrese-card" bordered={false}>
                        <FormSemContrato
                            key={location.search || '_'}
                            initialVendedorId={initialVendedorId}
                            vendedorLocked={vendedorLocked}
                            onSuccess={handleSuccess}
                        />
                    </Card>
                </div>
            </Col>
        </Row>
    );
};

export default CadastreSe;
